import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import DisclaimerModal from './DisclaimerModal';
import useDisclaimer from '../../hooks/useDisclaimer';

const Footer: React.FC = () => {
    const { isOpen: disclaimerOpen, openDisclaimer, closeDisclaimer } = useDisclaimer();

    return (
        <Box
            component="footer"
            sx={{
                mt: 'auto',
                width: '100%',
                boxShadow: '0 -2px 8px rgba(0,0,0,0.04)',
                backgroundColor: 'background.paper',
                borderTop: 1,
                borderColor: 'divider',
                py: 3,
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 1 }}>
                    © {new Date().getFullYear()} Tech for Palestine. All rights reserved.
                </Typography>
                <Link 
                    component="button"
                    variant="body2" 
                    onClick={openDisclaimer}
                    sx={{ 
                        textDecoration: 'none',
                        color: 'text.secondary',
                        '&:hover': {
                            textDecoration: 'underline'
                        }
                    }}
                >
                    Disclaimer
                </Link>
            </Box>
            <DisclaimerModal 
                open={disclaimerOpen} 
                onClose={closeDisclaimer} 
            />
        </Box>
    );
};

export default Footer;
